import React from "react";
import "../../styles/shared/error.css";
import errorImage from "../../assets/icon/nothing.png";  

export default function Error({ title = "Sistem müvəqqəti əlçatmazdır" }) {
  return (
    <div className="error-wrapper">
      <img src={errorImage} alt="error" className="error-image" />
      <h2 className="error-title">{title}</h2>
    </div>
  );
}
